import { defineStore } from 'pinia';
import api from '@/services/api';

export const useCategoriaIVAStore = defineStore('categoriaIVAStore', {
  state: () => ({
    categoriasIVA: [],
    page: 1,
  }),

  getters: {},

  actions: {
    async findAllCategoriasIVAHTTP() {
      const result = await api.get('/categorias-iva', { params: { page: +this.page } });
      if (result && result.data && result.data.length > 0) {
        this.categoriasIVA.push(...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },
    setPage(page) {
      this.page = page;
    },
    async firstCategoriasIVA() {
      this.setPage(1);
      this.emptyList();
      await this.findAllCategoriasIVAHTTP();
    },
    emptyList() {
      this.categoriasIVA = [];
    },
  },
});
